import { KeyCode } from 'cc';

enum KeyCodeMap {
    None = KeyCode.NONE,
    A = KeyCode.KEY_A,
    B = KeyCode.KEY_B,
    C = KeyCode.KEY_C,
    D = KeyCode.KEY_D,
    E = KeyCode.KEY_E,
    F = KeyCode.KEY_F,
    G = KeyCode.KEY_G,
    H = KeyCode.KEY_H,
    I = KeyCode.KEY_I,
    J = KeyCode.KEY_J,
    K = KeyCode.KEY_K,
    L = KeyCode.KEY_L,
    M = KeyCode.KEY_M,
    N = KeyCode.KEY_N,
    O = KeyCode.KEY_O,
    P = KeyCode.KEY_P,
    Q = KeyCode.KEY_Q,
    R = KeyCode.KEY_R,
    S = KeyCode.KEY_S,
    T = KeyCode.KEY_T,
    U = KeyCode.KEY_U,
    V = KeyCode.KEY_V,
    W = KeyCode.KEY_W,
    X = KeyCode.KEY_X,
    Y = KeyCode.KEY_Y,
    Z = KeyCode.KEY_Z,
    /* a=KeyCode.KEY_A,
    b=KeyCode.KEY_B,
    c=KeyCode.KEY_C,
    d=KeyCode.KEY_D,
    e=KeyCode.KEY_E,
    f=KeyCode.KEY_F,
    g=KeyCode.KEY_G,
    h=KeyCode.KEY_H,
    i=KeyCode.KEY_I,
    j=KeyCode.KEY_J,
    k=KeyCode.KEY_K,
    l=KeyCode.KEY_L,
    m=KeyCode.KEY_M,
    n=KeyCode.KEY_N,
    o=KeyCode.KEY_O,
    p=KeyCode.KEY_P,
    q=KeyCode.KEY_Q,
    r=KeyCode.KEY_R,
    s=KeyCode.KEY_S,
    t=KeyCode.KEY_T,
    u=KeyCode.KEY_U,
    v=KeyCode.KEY_V,
    w=KeyCode.KEY_W,
    x=KeyCode.KEY_X,
    y=KeyCode.KEY_Y,
    z=KeyCode.KEY_Z, */
    F1 = KeyCode.F1,
    F2 = KeyCode.F2,
    F3 = KeyCode.F3,
    F4 = KeyCode.F4,
    F5 = KeyCode.F5,
    F6 = KeyCode.F6,
    F7 = KeyCode.F7,
    F8 = KeyCode.F8,
    F9 = KeyCode.F9,
    F10 = KeyCode.F10,
    F11 = KeyCode.F11,
    F12 = KeyCode.F12,
    ';' = KeyCode.SEMICOLON,
    '=' = KeyCode.EQUAL,
    ',' = KeyCode.COMMA,
    '-' = KeyCode.DASH,
    '.' = KeyCode.PERIOD,
    '/' = KeyCode.SLASH,
    '`' = KeyCode.BACK_QUOTE,
    '[' = KeyCode.BRACKET_LEFT,
    ']' = KeyCode.BRACKET_RIGHT,
    '\\' = KeyCode.BACKSLASH,
    "'" = KeyCode.QUOTE,
    '數字鍵盤_1' = KeyCode.NUM_1,
    '數字鍵盤_2' = KeyCode.NUM_2,
    '數字鍵盤_3' = KeyCode.NUM_3,
    '數字鍵盤_4' = KeyCode.NUM_4,
    '數字鍵盤_5' = KeyCode.NUM_5,
    '數字鍵盤_6' = KeyCode.NUM_6,
    '數字鍵盤_7' = KeyCode.NUM_7,
    '數字鍵盤_8' = KeyCode.NUM_8,
    '數字鍵盤_9' = KeyCode.NUM_9,
    '數字鍵盤_0' = KeyCode.NUM_0,
    '*' = KeyCode.NUM_MULTIPLY,
    '+' = KeyCode.NUM_PLUS,
    '數字_0' = KeyCode.DIGIT_0,
    '數字_1' = KeyCode.DIGIT_1,
    '數字_2' = KeyCode.DIGIT_2,
    '數字_3' = KeyCode.DIGIT_3,
    '數字_4' = KeyCode.DIGIT_4,
    '數字_5' = KeyCode.DIGIT_5,
    '數字_6' = KeyCode.DIGIT_6,
    '數字_7' = KeyCode.DIGIT_7,
    '數字_8' = KeyCode.DIGIT_8,
    '數字_9' = KeyCode.DIGIT_9,
    '空白鍵' = KeyCode.SPACE,
    BACKSPACE = KeyCode.BACKSPACE,
}

export default KeyCodeMap;
